export const tooltipTime = 3000;
export const currentEscapeTime = 0.24;
export const targetEscapeTime = 2.3;
export const personSpeed = 0.25;
